import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteModelLabel = (token: string) => (
  modelId: number,
  labelId: number
) => deleteTemplateFn(token, uri.modelLabelById(modelId, labelId));
